/* eslint-disable @typescript-eslint/no-magic-numbers */
/* eslint-disable spellcheck/spell-checker */

import { GameType } from '../models/communication/app-enums.model';

/* eslint-disable @typescript-eslint/naming-convention */
export const demoHistoryData = [
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10709,
        openTime: 1758656481335,
        state: {
            cards: [
                {
                    card: 312,
                    index: 0
                },
                {
                    card: 401,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10709,
            handValue: 12,
            handValues: {
                Dragon: 12,
                Tiger: 1
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656509853
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10710,
        openTime: 1758656513864,
        state: {
            cards: [
                {
                    card: 202,
                    index: 0
                },
                {
                    card: 409,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10710,
            handValue: 9,
            handValues: {
                Dragon: 2,
                Tiger: 9
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656542382
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10711,
        openTime: 1758656546387,
        state: {
            cards: [
                {
                    card: 105,
                    index: 0
                },
                {
                    card: 103,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10711,
            handValue: 5,
            handValues: {
                Dragon: 5,
                Tiger: 3
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656574902
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10712,
        openTime: 1758656578908,
        state: {
            cards: [
                {
                    card: 405,
                    index: 0
                },
                {
                    card: 109,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10712,
            handValue: 9,
            handValues: {
                Dragon: 5,
                Tiger: 9
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656607423
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10713,
        openTime: 1758656611433,
        state: {
            cards: [
                {
                    card: 206,
                    index: 0
                },
                {
                    card: 207,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10713,
            handValue: 7,
            handValues: {
                Dragon: 6,
                Tiger: 7
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656639951
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10714,
        openTime: 1758656643961,
        state: {
            cards: [
                {
                    card: 301,
                    index: 0
                },
                {
                    card: 401,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10714,
            handValue: 1,
            handValues: {
                Dragon: 1,
                Tiger: 1
            },
            winner: [2]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656672484
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10715,
        openTime: 1758656676489,
        state: {
            cards: [
                {
                    card: 213,
                    index: 0
                },
                {
                    card: 106,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10715,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 6
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656705007
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10716,
        openTime: 1758656709013,
        state: {
            cards: [
                {
                    card: 408,
                    index: 0
                },
                {
                    card: 310,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10716,
            handValue: 10,
            handValues: {
                Dragon: 8,
                Tiger: 10
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656737533
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10717,
        openTime: 1758656741542,
        state: {
            cards: [
                {
                    card: 211,
                    index: 0
                },
                {
                    card: 101,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10717,
            handValue: 11,
            handValues: {
                Dragon: 11,
                Tiger: 1
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656770060
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10718,
        openTime: 1758656774066,
        state: {
            cards: [
                {
                    card: 406,
                    index: 0
                },
                {
                    card: 206,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10718,
            handValue: 6,
            handValues: {
                Dragon: 6,
                Tiger: 6
            },
            winner: [2]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656802585
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10719,
        openTime: 1758656806595,
        state: {
            cards: [
                {
                    card: 301,
                    index: 0
                },
                {
                    card: 207,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10719,
            handValue: 7,
            handValues: {
                Dragon: 1,
                Tiger: 7
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656835114
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10720,
        openTime: 1758656839124,
        state: {
            cards: [
                {
                    card: 401,
                    index: 0
                },
                {
                    card: 312,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10720,
            handValue: 12,
            handValues: {
                Dragon: 1,
                Tiger: 12
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656867642
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10721,
        openTime: 1758656871652,
        state: {
            cards: [
                {
                    card: 211,
                    index: 0
                },
                {
                    card: 413,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10721,
            handValue: 13,
            handValues: {
                Dragon: 11,
                Tiger: 13
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656900169
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10722,
        openTime: 1758656904180,
        state: {
            cards: [
                {
                    card: 402,
                    index: 0
                },
                {
                    card: 210,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10722,
            handValue: 10,
            handValues: {
                Dragon: 2,
                Tiger: 10
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656932698
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10723,
        openTime: 1758656936705,
        state: {
            cards: [
                {
                    card: 303,
                    index: 0
                },
                {
                    card: 201,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10723,
            handValue: 3,
            handValues: {
                Dragon: 3,
                Tiger: 1
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656965219
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10724,
        openTime: 1758656969225,
        state: {
            cards: [
                {
                    card: 108,
                    index: 0
                },
                {
                    card: 103,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10724,
            handValue: 8,
            handValues: {
                Dragon: 8,
                Tiger: 3
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758656997743
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10725,
        openTime: 1758657001755,
        state: {
            cards: [
                {
                    card: 313,
                    index: 0
                },
                {
                    card: 407,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10725,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 7
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657030271
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10726,
        openTime: 1758657034277,
        state: {
            cards: [
                {
                    card: 205,
                    index: 0
                },
                {
                    card: 301,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10726,
            handValue: 5,
            handValues: {
                Dragon: 5,
                Tiger: 1
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657062796
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10727,
        openTime: 1758657066806,
        state: {
            cards: [
                {
                    card: 407,
                    index: 0
                },
                {
                    card: 404,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10727,
            handValue: 7,
            handValues: {
                Dragon: 7,
                Tiger: 4
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657095323
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10728,
        openTime: 1758657099333,
        state: {
            cards: [
                {
                    card: 408,
                    index: 0
                },
                {
                    card: 113,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10728,
            handValue: 13,
            handValues: {
                Dragon: 8,
                Tiger: 13
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657127848
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10729,
        openTime: 1758657131856,
        state: {
            cards: [
                {
                    card: 109,
                    index: 0
                },
                {
                    card: 301,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10729,
            handValue: 9,
            handValues: {
                Dragon: 9,
                Tiger: 1
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657160374
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10730,
        openTime: 1758657164384,
        state: {
            cards: [
                {
                    card: 111,
                    index: 0
                },
                {
                    card: 312,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10730,
            handValue: 12,
            handValues: {
                Dragon: 11,
                Tiger: 12
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657192899
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10731,
        openTime: 1758657196909,
        state: {
            cards: [
                {
                    card: 201,
                    index: 0
                },
                {
                    card: 310,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10731,
            handValue: 10,
            handValues: {
                Dragon: 1,
                Tiger: 10
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657225427
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10732,
        openTime: 1758657229436,
        state: {
            cards: [
                {
                    card: 313,
                    index: 0
                },
                {
                    card: 305,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10732,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 5
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657257949
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10733,
        openTime: 1758657261960,
        state: {
            cards: [
                {
                    card: 412,
                    index: 0
                },
                {
                    card: 407,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10733,
            handValue: 12,
            handValues: {
                Dragon: 12,
                Tiger: 7
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657290477
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10734,
        openTime: 1758657294486,
        state: {
            cards: [
                {
                    card: 308,
                    index: 0
                },
                {
                    card: 301,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10734,
            handValue: 8,
            handValues: {
                Dragon: 8,
                Tiger: 1
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657323000
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10735,
        openTime: 1758657327009,
        state: {
            cards: [
                {
                    card: 305,
                    index: 0
                },
                {
                    card: 306,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10735,
            handValue: 6,
            handValues: {
                Dragon: 5,
                Tiger: 6
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657355529
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10736,
        openTime: 1758657359534,
        state: {
            cards: [
                {
                    card: 306,
                    index: 0
                },
                {
                    card: 404,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10736,
            handValue: 6,
            handValues: {
                Dragon: 6,
                Tiger: 4
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657388052
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10737,
        openTime: 1758657392058,
        state: {
            cards: [
                {
                    card: 212,
                    index: 0
                },
                {
                    card: 408,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10737,
            handValue: 12,
            handValues: {
                Dragon: 12,
                Tiger: 8
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657420577
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10738,
        openTime: 1758657424587,
        state: {
            cards: [
                {
                    card: 213,
                    index: 0
                },
                {
                    card: 404,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10738,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 4
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657453102
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10739,
        openTime: 1758657457107,
        state: {
            cards: [
                {
                    card: 207,
                    index: 0
                },
                {
                    card: 412,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10739,
            handValue: 12,
            handValues: {
                Dragon: 7,
                Tiger: 12
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657485626
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10740,
        openTime: 1758657489631,
        state: {
            cards: [
                {
                    card: 308,
                    index: 0
                },
                {
                    card: 310,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10740,
            handValue: 10,
            handValues: {
                Dragon: 8,
                Tiger: 10
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657518149
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10741,
        openTime: 1758657522159,
        state: {
            cards: [
                {
                    card: 409,
                    index: 0
                },
                {
                    card: 407,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10741,
            handValue: 9,
            handValues: {
                Dragon: 9,
                Tiger: 7
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657550678
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10742,
        openTime: 1758657554685,
        state: {
            cards: [
                {
                    card: 105,
                    index: 0
                },
                {
                    card: 402,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10742,
            handValue: 5,
            handValues: {
                Dragon: 5,
                Tiger: 2
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657583199
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10743,
        openTime: 1758657587205,
        state: {
            cards: [
                {
                    card: 105,
                    index: 0
                },
                {
                    card: 110,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10743,
            handValue: 10,
            handValues: {
                Dragon: 5,
                Tiger: 10
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657615721
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10744,
        openTime: 1758657619735,
        state: {
            cards: [
                {
                    card: 403,
                    index: 0
                },
                {
                    card: 406,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10744,
            handValue: 6,
            handValues: {
                Dragon: 3,
                Tiger: 6
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657648256
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10745,
        openTime: 1758657652262,
        state: {
            cards: [
                {
                    card: 304,
                    index: 0
                },
                {
                    card: 409,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10745,
            handValue: 9,
            handValues: {
                Dragon: 4,
                Tiger: 9
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657680777
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10746,
        openTime: 1758657684790,
        state: {
            cards: [
                {
                    card: 412,
                    index: 0
                },
                {
                    card: 103,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10746,
            handValue: 12,
            handValues: {
                Dragon: 12,
                Tiger: 3
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657713310
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10747,
        openTime: 1758657717316,
        state: {
            cards: [
                {
                    card: 113,
                    index: 0
                },
                {
                    card: 308,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10747,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 8
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657745835
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10748,
        openTime: 1758657749845,
        state: {
            cards: [
                {
                    card: 306,
                    index: 0
                },
                {
                    card: 313,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10748,
            handValue: 13,
            handValues: {
                Dragon: 6,
                Tiger: 13
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657778364
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10749,
        openTime: 1758657782374,
        state: {
            cards: [
                {
                    card: 302,
                    index: 0
                },
                {
                    card: 409,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10749,
            handValue: 9,
            handValues: {
                Dragon: 2,
                Tiger: 9
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657810891
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10750,
        openTime: 1758657814901,
        state: {
            cards: [
                {
                    card: 203,
                    index: 0
                },
                {
                    card: 401,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10750,
            handValue: 3,
            handValues: {
                Dragon: 3,
                Tiger: 1
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657843417
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10751,
        openTime: 1758657847426,
        state: {
            cards: [
                {
                    card: 110,
                    index: 0
                },
                {
                    card: 406,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10751,
            handValue: 10,
            handValues: {
                Dragon: 10,
                Tiger: 6
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657875944
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10752,
        openTime: 1758657879954,
        state: {
            cards: [
                {
                    card: 111,
                    index: 0
                },
                {
                    card: 111,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10752,
            handValue: 11,
            handValues: {
                Dragon: 11,
                Tiger: 11
            },
            winner: [2]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657908471
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10753,
        openTime: 1758657912477,
        state: {
            cards: [
                {
                    card: 208,
                    index: 0
                },
                {
                    card: 312,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10753,
            handValue: 12,
            handValues: {
                Dragon: 8,
                Tiger: 12
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657940993
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10754,
        openTime: 1758657945004,
        state: {
            cards: [
                {
                    card: 402,
                    index: 0
                },
                {
                    card: 113,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10754,
            handValue: 13,
            handValues: {
                Dragon: 2,
                Tiger: 13
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758657973519
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10755,
        openTime: 1758657977530,
        state: {
            cards: [
                {
                    card: 206,
                    index: 0
                },
                {
                    card: 408,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10755,
            handValue: 8,
            handValues: {
                Dragon: 6,
                Tiger: 8
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658006047
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10756,
        openTime: 1758658010053,
        state: {
            cards: [
                {
                    card: 402,
                    index: 0
                },
                {
                    card: 302,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10756,
            handValue: 2,
            handValues: {
                Dragon: 2,
                Tiger: 2
            },
            winner: [2]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658038573
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10757,
        openTime: 1758658042583,
        state: {
            cards: [
                {
                    card: 202,
                    index: 0
                },
                {
                    card: 206,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10757,
            handValue: 6,
            handValues: {
                Dragon: 2,
                Tiger: 6
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658071098
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10758,
        openTime: 1758658075109,
        state: {
            cards: [
                {
                    card: 413,
                    index: 0
                },
                {
                    card: 308,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10758,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 8
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658103626
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10759,
        openTime: 1758658107636,
        state: {
            cards: [
                {
                    card: 208,
                    index: 0
                },
                {
                    card: 209,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10759,
            handValue: 9,
            handValues: {
                Dragon: 8,
                Tiger: 9
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658136148
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10760,
        openTime: 1758658140157,
        state: {
            cards: [
                {
                    card: 209,
                    index: 0
                },
                {
                    card: 412,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10760,
            handValue: 12,
            handValues: {
                Dragon: 9,
                Tiger: 12
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658168674
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10761,
        openTime: 1758658172684,
        state: {
            cards: [
                {
                    card: 208,
                    index: 0
                },
                {
                    card: 209,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10761,
            handValue: 9,
            handValues: {
                Dragon: 8,
                Tiger: 9
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658201200
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10762,
        openTime: 1758658205206,
        state: {
            cards: [
                {
                    card: 101,
                    index: 0
                },
                {
                    card: 302,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10762,
            handValue: 2,
            handValues: {
                Dragon: 1,
                Tiger: 2
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658233723
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10763,
        openTime: 1758658237729,
        state: {
            cards: [
                {
                    card: 312,
                    index: 0
                },
                {
                    card: 102,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10763,
            handValue: 12,
            handValues: {
                Dragon: 12,
                Tiger: 2
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658266246
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10764,
        openTime: 1758658270257,
        state: {
            cards: [
                {
                    card: 304,
                    index: 0
                },
                {
                    card: 302,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10764,
            handValue: 4,
            handValues: {
                Dragon: 4,
                Tiger: 2
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658298775
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10765,
        openTime: 1758658302785,
        state: {
            cards: [
                {
                    card: 310,
                    index: 0
                },
                {
                    card: 302,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10765,
            handValue: 10,
            handValues: {
                Dragon: 10,
                Tiger: 2
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658331303
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10766,
        openTime: 1758658335313,
        state: {
            cards: [
                {
                    card: 310,
                    index: 0
                },
                {
                    card: 313,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10766,
            handValue: 13,
            handValues: {
                Dragon: 10,
                Tiger: 13
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658363827
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10767,
        openTime: 1758658367833,
        state: {
            cards: [
                {
                    card: 406,
                    index: 0
                },
                {
                    card: 202,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10767,
            handValue: 6,
            handValues: {
                Dragon: 6,
                Tiger: 2
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658396352
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10768,
        openTime: 1758658400361,
        state: {
            cards: [
                {
                    card: 411,
                    index: 0
                },
                {
                    card: 408,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10768,
            handValue: 11,
            handValues: {
                Dragon: 11,
                Tiger: 8
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658428879
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10769,
        openTime: 1758658432885,
        state: {
            cards: [
                {
                    card: 107,
                    index: 0
                },
                {
                    card: 207,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10769,
            handValue: 7,
            handValues: {
                Dragon: 7,
                Tiger: 7
            },
            winner: [2]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658461404
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10770,
        openTime: 1758658465413,
        state: {
            cards: [
                {
                    card: 102,
                    index: 0
                },
                {
                    card: 209,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10770,
            handValue: 9,
            handValues: {
                Dragon: 2,
                Tiger: 9
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658493930
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10771,
        openTime: 1758658497936,
        state: {
            cards: [
                {
                    card: 309,
                    index: 0
                },
                {
                    card: 213,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10771,
            handValue: 13,
            handValues: {
                Dragon: 9,
                Tiger: 13
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658526455
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10772,
        openTime: 1758658530465,
        state: {
            cards: [
                {
                    card: 203,
                    index: 0
                },
                {
                    card: 210,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10772,
            handValue: 10,
            handValues: {
                Dragon: 3,
                Tiger: 10
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658558980
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10773,
        openTime: 1758658562989,
        state: {
            cards: [
                {
                    card: 402,
                    index: 0
                },
                {
                    card: 301,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10773,
            handValue: 2,
            handValues: {
                Dragon: 2,
                Tiger: 1
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658591508
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10774,
        openTime: 1758658595518,
        state: {
            cards: [
                {
                    card: 106,
                    index: 0
                },
                {
                    card: 405,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10774,
            handValue: 6,
            handValues: {
                Dragon: 6,
                Tiger: 5
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658624033
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10775,
        openTime: 1758658628043,
        state: {
            cards: [
                {
                    card: 108,
                    index: 0
                },
                {
                    card: 207,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10775,
            handValue: 8,
            handValues: {
                Dragon: 8,
                Tiger: 7
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658656561
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10776,
        openTime: 1758658660571,
        state: {
            cards: [
                {
                    card: 309,
                    index: 0
                },
                {
                    card: 303,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10776,
            handValue: 9,
            handValues: {
                Dragon: 9,
                Tiger: 3
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658689087
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10777,
        openTime: 1758658693093,
        state: {
            cards: [
                {
                    card: 102,
                    index: 0
                },
                {
                    card: 211,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10777,
            handValue: 11,
            handValues: {
                Dragon: 2,
                Tiger: 11
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658721609
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10778,
        openTime: 1758658725615,
        state: {
            cards: [
                {
                    card: 401,
                    index: 0
                },
                {
                    card: 106,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10778,
            handValue: 6,
            handValues: {
                Dragon: 1,
                Tiger: 6
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658754134
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10779,
        openTime: 1758658758144,
        state: {
            cards: [
                {
                    card: 311,
                    index: 0
                },
                {
                    card: 112,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10779,
            handValue: 12,
            handValues: {
                Dragon: 11,
                Tiger: 12
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658786664
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10780,
        openTime: 1758658790674,
        state: {
            cards: [
                {
                    card: 211,
                    index: 0
                },
                {
                    card: 405,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10780,
            handValue: 11,
            handValues: {
                Dragon: 11,
                Tiger: 5
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658819193
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10781,
        openTime: 1758658823199,
        state: {
            cards: [
                {
                    card: 311,
                    index: 0
                },
                {
                    card: 103,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10781,
            handValue: 11,
            handValues: {
                Dragon: 11,
                Tiger: 3
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658851716
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10782,
        openTime: 1758658855722,
        state: {
            cards: [
                {
                    card: 213,
                    index: 0
                },
                {
                    card: 107,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10782,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 7
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658884243
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10783,
        openTime: 1758658888252,
        state: {
            cards: [
                {
                    card: 311,
                    index: 0
                },
                {
                    card: 309,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10783,
            handValue: 11,
            handValues: {
                Dragon: 11,
                Tiger: 9
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658916767
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10784,
        openTime: 1758658920772,
        state: {
            cards: [
                {
                    card: 103,
                    index: 0
                },
                {
                    card: 209,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10784,
            handValue: 9,
            handValues: {
                Dragon: 3,
                Tiger: 9
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658949291
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10785,
        openTime: 1758658953297,
        state: {
            cards: [
                {
                    card: 306,
                    index: 0
                },
                {
                    card: 113,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10785,
            handValue: 13,
            handValues: {
                Dragon: 6,
                Tiger: 13
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758658981814
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10786,
        openTime: 1758658985824,
        state: {
            cards: [
                {
                    card: 413,
                    index: 0
                },
                {
                    card: 311,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10786,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 11
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659014342
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10787,
        openTime: 1758659018352,
        state: {
            cards: [
                {
                    card: 113,
                    index: 0
                },
                {
                    card: 407,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10787,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 7
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659046869
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10788,
        openTime: 1758659050879,
        state: {
            cards: [
                {
                    card: 110,
                    index: 0
                },
                {
                    card: 109,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10788,
            handValue: 10,
            handValues: {
                Dragon: 10,
                Tiger: 9
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659079396
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10789,
        openTime: 1758659083406,
        state: {
            cards: [
                {
                    card: 101,
                    index: 0
                },
                {
                    card: 411,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10789,
            handValue: 11,
            handValues: {
                Dragon: 1,
                Tiger: 11
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659111922
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10790,
        openTime: 1758659115931,
        state: {
            cards: [
                {
                    card: 409,
                    index: 0
                },
                {
                    card: 207,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10790,
            handValue: 9,
            handValues: {
                Dragon: 9,
                Tiger: 7
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659144448
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10791,
        openTime: 1758659148455,
        state: {
            cards: [
                {
                    card: 402,
                    index: 0
                },
                {
                    card: 106,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10791,
            handValue: 6,
            handValues: {
                Dragon: 2,
                Tiger: 6
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659176974
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10792,
        openTime: 1758659180984,
        state: {
            cards: [
                {
                    card: 102,
                    index: 0
                },
                {
                    card: 205,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10792,
            handValue: 5,
            handValues: {
                Dragon: 2,
                Tiger: 5
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659209503
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10793,
        openTime: 1758659213509,
        state: {
            cards: [
                {
                    card: 202,
                    index: 0
                },
                {
                    card: 304,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10793,
            handValue: 4,
            handValues: {
                Dragon: 2,
                Tiger: 4
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659242026
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10794,
        openTime: 1758659246035,
        state: {
            cards: [
                {
                    card: 105,
                    index: 0
                },
                {
                    card: 305,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10794,
            handValue: 5,
            handValues: {
                Dragon: 5,
                Tiger: 5
            },
            winner: [2]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659274553
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10795,
        openTime: 1758659278563,
        state: {
            cards: [
                {
                    card: 311,
                    index: 0
                },
                {
                    card: 106,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10795,
            handValue: 11,
            handValues: {
                Dragon: 11,
                Tiger: 6
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659307078
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10796,
        openTime: 1758659311088,
        state: {
            cards: [
                {
                    card: 113,
                    index: 0
                },
                {
                    card: 303,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10796,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 3
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659339606
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10797,
        openTime: 1758659343615,
        state: {
            cards: [
                {
                    card: 411,
                    index: 0
                },
                {
                    card: 102,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10797,
            handValue: 11,
            handValues: {
                Dragon: 11,
                Tiger: 2
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659372132
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10798,
        openTime: 1758659376139,
        state: {
            cards: [
                {
                    card: 307,
                    index: 0
                },
                {
                    card: 313,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10798,
            handValue: 13,
            handValues: {
                Dragon: 7,
                Tiger: 13
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659404652
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10799,
        openTime: 1758659408658,
        state: {
            cards: [
                {
                    card: 109,
                    index: 0
                },
                {
                    card: 105,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10799,
            handValue: 9,
            handValues: {
                Dragon: 9,
                Tiger: 5
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659437175
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10800,
        openTime: 1758659441185,
        state: {
            cards: [
                {
                    card: 413,
                    index: 0
                },
                {
                    card: 213,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10800,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 13
            },
            winner: [2]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659469699
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10801,
        openTime: 1758659473708,
        state: {
            cards: [
                {
                    card: 111,
                    index: 0
                },
                {
                    card: 408,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10801,
            handValue: 11,
            handValues: {
                Dragon: 11,
                Tiger: 8
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659502222
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10802,
        openTime: 1758659506232,
        state: {
            cards: [
                {
                    card: 209,
                    index: 0
                },
                {
                    card: 312,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10802,
            handValue: 12,
            handValues: {
                Dragon: 9,
                Tiger: 12
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659534751
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10803,
        openTime: 1758659538761,
        state: {
            cards: [
                {
                    card: 402,
                    index: 0
                },
                {
                    card: 201,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10803,
            handValue: 2,
            handValues: {
                Dragon: 2,
                Tiger: 1
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659567276
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10804,
        openTime: 1758659571282,
        state: {
            cards: [
                {
                    card: 411,
                    index: 0
                },
                {
                    card: 312,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10804,
            handValue: 12,
            handValues: {
                Dragon: 11,
                Tiger: 12
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659599800
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10805,
        openTime: 1758659603809,
        state: {
            cards: [
                {
                    card: 409,
                    index: 0
                },
                {
                    card: 404,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10805,
            handValue: 9,
            handValues: {
                Dragon: 9,
                Tiger: 4
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659632324
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10806,
        openTime: 1758659636331,
        state: {
            cards: [
                {
                    card: 201,
                    index: 0
                },
                {
                    card: 111,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10806,
            handValue: 11,
            handValues: {
                Dragon: 1,
                Tiger: 11
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659664849
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10807,
        openTime: 1758659668859,
        state: {
            cards: [
                {
                    card: 404,
                    index: 0
                },
                {
                    card: 409,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10807,
            handValue: 9,
            handValues: {
                Dragon: 4,
                Tiger: 9
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659697376
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10808,
        openTime: 1758659701382,
        state: {
            cards: [
                {
                    card: 105,
                    index: 0
                },
                {
                    card: 407,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10808,
            handValue: 7,
            handValues: {
                Dragon: 5,
                Tiger: 7
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659729900
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10809,
        openTime: 1758659733909,
        state: {
            cards: [
                {
                    card: 112,
                    index: 0
                },
                {
                    card: 211,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10809,
            handValue: 12,
            handValues: {
                Dragon: 12,
                Tiger: 11
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659762427
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10810,
        openTime: 1758659766435,
        state: {
            cards: [
                {
                    card: 301,
                    index: 0
                },
                {
                    card: 313,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10810,
            handValue: 13,
            handValues: {
                Dragon: 1,
                Tiger: 13
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659794954
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10811,
        openTime: 1758659798964,
        state: {
            cards: [
                {
                    card: 205,
                    index: 0
                },
                {
                    card: 103,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10811,
            handValue: 5,
            handValues: {
                Dragon: 5,
                Tiger: 3
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659827478
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10812,
        openTime: 1758659831484,
        state: {
            cards: [
                {
                    card: 104,
                    index: 0
                },
                {
                    card: 312,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10812,
            handValue: 12,
            handValues: {
                Dragon: 4,
                Tiger: 12
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659859998
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10813,
        openTime: 1758659864008,
        state: {
            cards: [
                {
                    card: 104,
                    index: 0
                },
                {
                    card: 308,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10813,
            handValue: 8,
            handValues: {
                Dragon: 4,
                Tiger: 8
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659892526
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10814,
        openTime: 1758659896531,
        state: {
            cards: [
                {
                    card: 305,
                    index: 0
                },
                {
                    card: 304,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10814,
            handValue: 5,
            handValues: {
                Dragon: 5,
                Tiger: 4
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659925049
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10815,
        openTime: 1758659929055,
        state: {
            cards: [
                {
                    card: 101,
                    index: 0
                },
                {
                    card: 412,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10815,
            handValue: 12,
            handValues: {
                Dragon: 1,
                Tiger: 12
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659957569
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10816,
        openTime: 1758659961579,
        state: {
            cards: [
                {
                    card: 113,
                    index: 0
                },
                {
                    card: 213,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10816,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 13
            },
            winner: [2]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758659990099
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10817,
        openTime: 1758659994105,
        state: {
            cards: [
                {
                    card: 210,
                    index: 0
                },
                {
                    card: 305,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10817,
            handValue: 10,
            handValues: {
                Dragon: 10,
                Tiger: 5
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660022624
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10818,
        openTime: 1758660026630,
        state: {
            cards: [
                {
                    card: 306,
                    index: 0
                },
                {
                    card: 109,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10818,
            handValue: 9,
            handValues: {
                Dragon: 6,
                Tiger: 9
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660055149
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10819,
        openTime: 1758660059159,
        state: {
            cards: [
                {
                    card: 407,
                    index: 0
                },
                {
                    card: 301,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10819,
            handValue: 7,
            handValues: {
                Dragon: 7,
                Tiger: 1
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660087678
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10820,
        openTime: 1758660091688,
        state: {
            cards: [
                {
                    card: 405,
                    index: 0
                },
                {
                    card: 307,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10820,
            handValue: 7,
            handValues: {
                Dragon: 5,
                Tiger: 7
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660120205
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10821,
        openTime: 1758660124213,
        state: {
            cards: [
                {
                    card: 205,
                    index: 0
                },
                {
                    card: 308,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10821,
            handValue: 8,
            handValues: {
                Dragon: 5,
                Tiger: 8
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660152733
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10822,
        openTime: 1758660156743,
        state: {
            cards: [
                {
                    card: 203,
                    index: 0
                },
                {
                    card: 301,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10822,
            handValue: 3,
            handValues: {
                Dragon: 3,
                Tiger: 1
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660185262
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10823,
        openTime: 1758660189272,
        state: {
            cards: [
                {
                    card: 402,
                    index: 0
                },
                {
                    card: 208,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10823,
            handValue: 8,
            handValues: {
                Dragon: 2,
                Tiger: 8
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660217786
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10824,
        openTime: 1758660221793,
        state: {
            cards: [
                {
                    card: 105,
                    index: 0
                },
                {
                    card: 207,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10824,
            handValue: 7,
            handValues: {
                Dragon: 5,
                Tiger: 7
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660250306
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10825,
        openTime: 1758660254311,
        state: {
            cards: [
                {
                    card: 201,
                    index: 0
                },
                {
                    card: 113,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10825,
            handValue: 13,
            handValues: {
                Dragon: 1,
                Tiger: 13
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660282829
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10826,
        openTime: 1758660286839,
        state: {
            cards: [
                {
                    card: 213,
                    index: 0
                },
                {
                    card: 310,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10826,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 10
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660315354
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10827,
        openTime: 1758660319360,
        state: {
            cards: [
                {
                    card: 113,
                    index: 0
                },
                {
                    card: 211,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10827,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 11
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660347875
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10828,
        openTime: 1758660351886,
        state: {
            cards: [
                {
                    card: 403,
                    index: 0
                },
                {
                    card: 313,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10828,
            handValue: 13,
            handValues: {
                Dragon: 3,
                Tiger: 13
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660380403
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10829,
        openTime: 1758660384412,
        state: {
            cards: [
                {
                    card: 208,
                    index: 0
                },
                {
                    card: 102,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10829,
            handValue: 8,
            handValues: {
                Dragon: 8,
                Tiger: 2
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660412928
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10830,
        openTime: 1758660416937,
        state: {
            cards: [
                {
                    card: 213,
                    index: 0
                },
                {
                    card: 408,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10830,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 8
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660445455
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10831,
        openTime: 1758660449464,
        state: {
            cards: [
                {
                    card: 210,
                    index: 0
                },
                {
                    card: 102,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10831,
            handValue: 10,
            handValues: {
                Dragon: 10,
                Tiger: 2
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660477980
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10832,
        openTime: 1758660481988,
        state: {
            cards: [
                {
                    card: 404,
                    index: 0
                },
                {
                    card: 106,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10832,
            handValue: 6,
            handValues: {
                Dragon: 4,
                Tiger: 6
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660510505
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10833,
        openTime: 1758660514515,
        state: {
            cards: [
                {
                    card: 206,
                    index: 0
                },
                {
                    card: 104,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10833,
            handValue: 6,
            handValues: {
                Dragon: 6,
                Tiger: 4
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660543032
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10834,
        openTime: 1758660547041,
        state: {
            cards: [
                {
                    card: 303,
                    index: 0
                },
                {
                    card: 203,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10834,
            handValue: 3,
            handValues: {
                Dragon: 3,
                Tiger: 3
            },
            winner: [2]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660575555
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10835,
        openTime: 1758660579564,
        state: {
            cards: [
                {
                    card: 312,
                    index: 0
                },
                {
                    card: 208,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10835,
            handValue: 12,
            handValues: {
                Dragon: 12,
                Tiger: 8
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660608079
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10836,
        openTime: 1758660612084,
        state: {
            cards: [
                {
                    card: 309,
                    index: 0
                },
                {
                    card: 311,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10836,
            handValue: 11,
            handValues: {
                Dragon: 9,
                Tiger: 11
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660640605
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10837,
        openTime: 1758660644615,
        state: {
            cards: [
                {
                    card: 411,
                    index: 0
                },
                {
                    card: 303,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10837,
            handValue: 11,
            handValues: {
                Dragon: 11,
                Tiger: 3
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660673131
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10838,
        openTime: 1758660677136,
        state: {
            cards: [
                {
                    card: 413,
                    index: 0
                },
                {
                    card: 409,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10838,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 9
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660705706
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10839,
        openTime: 1758660709715,
        state: {
            cards: [
                {
                    card: 404,
                    index: 0
                },
                {
                    card: 307,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10839,
            handValue: 7,
            handValues: {
                Dragon: 4,
                Tiger: 7
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660738233
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10840,
        openTime: 1758660742239,
        state: {
            cards: [
                {
                    card: 212,
                    index: 0
                },
                {
                    card: 413,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10840,
            handValue: 13,
            handValues: {
                Dragon: 12,
                Tiger: 13
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660770758
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10841,
        openTime: 1758660774767,
        state: {
            cards: [
                {
                    card: 101,
                    index: 0
                },
                {
                    card: 303,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10841,
            handValue: 3,
            handValues: {
                Dragon: 1,
                Tiger: 3
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660803282
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10842,
        openTime: 1758660807289,
        state: {
            cards: [
                {
                    card: 410,
                    index: 0
                },
                {
                    card: 110,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10842,
            handValue: 10,
            handValues: {
                Dragon: 10,
                Tiger: 10
            },
            winner: [2]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660835806
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10843,
        openTime: 1758660839816,
        state: {
            cards: [
                {
                    card: 105,
                    index: 0
                },
                {
                    card: 109,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10843,
            handValue: 9,
            handValues: {
                Dragon: 5,
                Tiger: 9
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660868333
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10844,
        openTime: 1758660872343,
        state: {
            cards: [
                {
                    card: 410,
                    index: 0
                },
                {
                    card: 312,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10844,
            handValue: 12,
            handValues: {
                Dragon: 10,
                Tiger: 12
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660900863
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10845,
        openTime: 1758660904873,
        state: {
            cards: [
                {
                    card: 411,
                    index: 0
                },
                {
                    card: 405,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10845,
            handValue: 11,
            handValues: {
                Dragon: 11,
                Tiger: 5
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660933388
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10846,
        openTime: 1758660937395,
        state: {
            cards: [
                {
                    card: 301,
                    index: 0
                },
                {
                    card: 408,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10846,
            handValue: 8,
            handValues: {
                Dragon: 1,
                Tiger: 8
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660965914
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10847,
        openTime: 1758660969919,
        state: {
            cards: [
                {
                    card: 113,
                    index: 0
                },
                {
                    card: 403,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10847,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 3
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758660998437
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10848,
        openTime: 1758661002447,
        state: {
            cards: [
                {
                    card: 307,
                    index: 0
                },
                {
                    card: 409,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10848,
            handValue: 9,
            handValues: {
                Dragon: 7,
                Tiger: 9
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661030966
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10849,
        openTime: 1758661034976,
        state: {
            cards: [
                {
                    card: 201,
                    index: 0
                },
                {
                    card: 205,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10849,
            handValue: 5,
            handValues: {
                Dragon: 1,
                Tiger: 5
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661063496
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10850,
        openTime: 1758661067501,
        state: {
            cards: [
                {
                    card: 301,
                    index: 0
                },
                {
                    card: 313,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10850,
            handValue: 13,
            handValues: {
                Dragon: 1,
                Tiger: 13
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661096015
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10851,
        openTime: 1758661100025,
        state: {
            cards: [
                {
                    card: 102,
                    index: 0
                },
                {
                    card: 109,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10851,
            handValue: 9,
            handValues: {
                Dragon: 2,
                Tiger: 9
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661128539
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10852,
        openTime: 1758661132548,
        state: {
            cards: [
                {
                    card: 301,
                    index: 0
                },
                {
                    card: 308,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10852,
            handValue: 8,
            handValues: {
                Dragon: 1,
                Tiger: 8
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661161065
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10853,
        openTime: 1758661165072,
        state: {
            cards: [
                {
                    card: 304,
                    index: 0
                },
                {
                    card: 401,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10853,
            handValue: 4,
            handValues: {
                Dragon: 4,
                Tiger: 1
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661193591
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10854,
        openTime: 1758661197600,
        state: {
            cards: [
                {
                    card: 101,
                    index: 0
                },
                {
                    card: 210,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10854,
            handValue: 10,
            handValues: {
                Dragon: 1,
                Tiger: 10
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661226119
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10855,
        openTime: 1758661230125,
        state: {
            cards: [
                {
                    card: 109,
                    index: 0
                },
                {
                    card: 409,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10855,
            handValue: 9,
            handValues: {
                Dragon: 9,
                Tiger: 9
            },
            winner: [2]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661258644
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10856,
        openTime: 1758661262654,
        state: {
            cards: [
                {
                    card: 213,
                    index: 0
                },
                {
                    card: 401,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10856,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 1
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661291173
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10857,
        openTime: 1758661295179,
        state: {
            cards: [
                {
                    card: 112,
                    index: 0
                },
                {
                    card: 404,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10857,
            handValue: 12,
            handValues: {
                Dragon: 12,
                Tiger: 4
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661323693
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10858,
        openTime: 1758661327703,
        state: {
            cards: [
                {
                    card: 304,
                    index: 0
                },
                {
                    card: 202,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10858,
            handValue: 4,
            handValues: {
                Dragon: 4,
                Tiger: 2
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661356222
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10859,
        openTime: 1758661360230,
        state: {
            cards: [
                {
                    card: 312,
                    index: 0
                },
                {
                    card: 305,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10859,
            handValue: 12,
            handValues: {
                Dragon: 12,
                Tiger: 5
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661388744
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10860,
        openTime: 1758661392754,
        state: {
            cards: [
                {
                    card: 207,
                    index: 0
                },
                {
                    card: 208,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10860,
            handValue: 8,
            handValues: {
                Dragon: 7,
                Tiger: 8
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661421273
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10861,
        openTime: 1758661425283,
        state: {
            cards: [
                {
                    card: 411,
                    index: 0
                },
                {
                    card: 211,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10861,
            handValue: 11,
            handValues: {
                Dragon: 11,
                Tiger: 11
            },
            winner: [2]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661453802
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10862,
        openTime: 1758661457810,
        state: {
            cards: [
                {
                    card: 408,
                    index: 0
                },
                {
                    card: 312,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10862,
            handValue: 12,
            handValues: {
                Dragon: 8,
                Tiger: 12
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661486329
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10863,
        openTime: 1758661490339,
        state: {
            cards: [
                {
                    card: 302,
                    index: 0
                },
                {
                    card: 308,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10863,
            handValue: 8,
            handValues: {
                Dragon: 2,
                Tiger: 8
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661518857
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10864,
        openTime: 1758661522867,
        state: {
            cards: [
                {
                    card: 301,
                    index: 0
                },
                {
                    card: 411,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10864,
            handValue: 11,
            handValues: {
                Dragon: 1,
                Tiger: 11
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661551380
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10865,
        openTime: 1758661555391,
        state: {
            cards: [
                {
                    card: 206,
                    index: 0
                },
                {
                    card: 407,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10865,
            handValue: 7,
            handValues: {
                Dragon: 6,
                Tiger: 7
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661583909
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10866,
        openTime: 1758661587914,
        state: {
            cards: [
                {
                    card: 307,
                    index: 0
                },
                {
                    card: 206,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10866,
            handValue: 7,
            handValues: {
                Dragon: 7,
                Tiger: 6
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661616429
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10867,
        openTime: 1758661620440,
        state: {
            cards: [
                {
                    card: 309,
                    index: 0
                },
                {
                    card: 102,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10867,
            handValue: 9,
            handValues: {
                Dragon: 9,
                Tiger: 2
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661648953
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10868,
        openTime: 1758661652963,
        state: {
            cards: [
                {
                    card: 213,
                    index: 0
                },
                {
                    card: 412,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10868,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 12
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661681478
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10869,
        openTime: 1758661685485,
        state: {
            cards: [
                {
                    card: 103,
                    index: 0
                },
                {
                    card: 301,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10869,
            handValue: 3,
            handValues: {
                Dragon: 3,
                Tiger: 1
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661714004
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10870,
        openTime: 1758661718014,
        state: {
            cards: [
                {
                    card: 213,
                    index: 0
                },
                {
                    card: 202,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10870,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 2
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661746533
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10871,
        openTime: 1758661750543,
        state: {
            cards: [
                {
                    card: 302,
                    index: 0
                },
                {
                    card: 206,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10871,
            handValue: 6,
            handValues: {
                Dragon: 2,
                Tiger: 6
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661779060
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10872,
        openTime: 1758661783070,
        state: {
            cards: [
                {
                    card: 106,
                    index: 0
                },
                {
                    card: 208,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10872,
            handValue: 8,
            handValues: {
                Dragon: 6,
                Tiger: 8
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661811594
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10873,
        openTime: 1758661815603,
        state: {
            cards: [
                {
                    card: 208,
                    index: 0
                },
                {
                    card: 210,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10873,
            handValue: 10,
            handValues: {
                Dragon: 8,
                Tiger: 10
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661844123
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10874,
        openTime: 1758661848133,
        state: {
            cards: [
                {
                    card: 406,
                    index: 0
                },
                {
                    card: 304,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10874,
            handValue: 6,
            handValues: {
                Dragon: 6,
                Tiger: 4
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661876648
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10875,
        openTime: 1758661880660,
        state: {
            cards: [
                {
                    card: 213,
                    index: 0
                },
                {
                    card: 303,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10875,
            handValue: 13,
            handValues: {
                Dragon: 13,
                Tiger: 3
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661909178
    },
    {
        croupier: 'F0F0F0F0',
        gameType: 'DragonTiger' as GameType,
        id: 10876,
        openTime: 1758661913187,
        state: {
            cards: [
                {
                    card: 211,
                    index: 0
                },
                {
                    card: 110,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10876,
            handValue: 11,
            handValues: {
                Dragon: 11,
                Tiger: 10
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758661941705
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'DragonTiger' as GameType,
        id: 10877,
        openTime: 1758698723122,
        state: {
            cards: [
                {
                    card: 204,
                    index: 0
                },
                {
                    card: 407,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10877,
            handValue: 7,
            handValues: {
                Dragon: 4,
                Tiger: 7
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758698751649
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'DragonTiger' as GameType,
        id: 10878,
        openTime: 1758698755662,
        state: {
            cards: [
                {
                    card: 407,
                    index: 0
                },
                {
                    card: 102,
                    index: 1
                }
            ],
            extraData: null,
            gameNumber: 10878,
            handValue: 7,
            handValues: {
                Dragon: 7,
                Tiger: 2
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758698784188
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'Baccarat' as GameType,
        id: 10879,
        openTime: 1758699559078,
        state: {
            cards: [
                {
                    card: 207,
                    index: 0
                },
                {
                    card: 207,
                    index: 1
                },
                {
                    card: 109,
                    index: 2
                },
                {
                    card: 301,
                    index: 3
                },
                {
                    card: 301,
                    index: 4
                },
                {
                    card: 304,
                    index: 5
                }
            ],
            extraData: {
                bankerPair: false,
                naturals: false,
                playerPair: true
            },
            gameNumber: 10879,
            handValue: 5,
            handValues: {
                Banker: 4,
                Player: 5
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758699593618
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'Baccarat' as GameType,
        id: 10880,
        openTime: 1758699597629,
        state: {
            cards: [
                {
                    card: 402,
                    index: 0
                },
                {
                    card: 204,
                    index: 1
                },
                {
                    card: 202,
                    index: 2
                },
                {
                    card: 211,
                    index: 3
                },
                {
                    card: 407,
                    index: 5
                }
            ],
            extraData: {
                bankerPair: false,
                naturals: true,
                playerPair: false
            },
            gameNumber: 10880,
            handValue: 9,
            handValues: {
                Banker: 9,
                Player: 6
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758699630164
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'Baccarat' as GameType,
        id: 10881,
        openTime: 1758699634174,
        state: {
            cards: [
                {
                    card: 107,
                    index: 0
                },
                {
                    card: 206,
                    index: 1
                },
                {
                    card: 113,
                    index: 2
                },
                {
                    card: 313,
                    index: 3
                },
                {
                    card: 410,
                    index: 4
                },
                {
                    card: 113,
                    index: 5
                }
            ],
            extraData: {
                bankerPair: true,
                naturals: false,
                playerPair: false
            },
            gameNumber: 10881,
            handValue: 3,
            handValues: {
                Banker: 0,
                Player: 3
            },
            winner: [0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758699668719
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'Baccarat' as GameType,
        id: 10882,
        openTime: 1758699672728,
        state: {
            cards: [
                {
                    card: 110,
                    index: 0
                },
                {
                    card: 311,
                    index: 1
                },
                {
                    card: 412,
                    index: 2
                },
                {
                    card: 201,
                    index: 3
                },
                {
                    card: 305,
                    index: 4
                },
                {
                    card: 105,
                    index: 5
                }
            ],
            extraData: {
                bankerPair: false,
                naturals: false,
                playerPair: false
            },
            gameNumber: 10882,
            handValue: 6,
            handValues: {
                Banker: 6,
                Player: 5
            },
            winner: [1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758699748981
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'Baccarat' as GameType,
        id: 10883,
        openTime: 1758699752993,
        state: {
            cards: [
                {
                    card: 407,
                    index: 0
                },
                {
                    card: 310,
                    index: 1
                },
                {
                    card: 307,
                    index: 2
                },
                {
                    card: 412,
                    index: 3
                }
            ],
            extraData: {
                bankerPair: false,
                naturals: false,
                playerPair: false
            },
            gameNumber: 10883,
            handValue: 7,
            handValues: {
                Banker: 7,
                Player: 7
            },
            winner: [2]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758699783532
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10884,
        openTime: 1758699807577,
        state: {
            cards: [
                {
                    card: 209,
                    index: 0
                },
                {
                    card: 304,
                    index: 1
                },
                {
                    card: 308,
                    index: 2
                },
                {
                    card: 312,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10884,
            handValue: 0,
            handValues: {
                BlackDragon: 4,
                GoldenDragon: 9,
                RedDragon: 8,
                Tiger: 12
            },
            winner: [1, 1, 1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758699847127
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10885,
        openTime: 1758699851138,
        state: {
            cards: [
                {
                    card: 303,
                    index: 0
                },
                {
                    card: 310,
                    index: 1
                },
                {
                    card: 109,
                    index: 2
                },
                {
                    card: 201,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10885,
            handValue: 0,
            handValues: {
                BlackDragon: 10,
                GoldenDragon: 3,
                RedDragon: 9,
                Tiger: 1
            },
            winner: [0, 0, 0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758699890690
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10886,
        openTime: 1758699894702,
        state: {
            cards: [
                {
                    card: 212,
                    index: 0
                },
                {
                    card: 105,
                    index: 1
                },
                {
                    card: 312,
                    index: 2
                },
                {
                    card: 209,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10886,
            handValue: 0,
            handValues: {
                BlackDragon: 5,
                GoldenDragon: 12,
                RedDragon: 12,
                Tiger: 9
            },
            winner: [0, 1, 0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758699934253
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10887,
        openTime: 1758699938263,
        state: {
            cards: [
                {
                    card: 308,
                    index: 0
                },
                {
                    card: 213,
                    index: 1
                },
                {
                    card: 212,
                    index: 2
                },
                {
                    card: 302,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10887,
            handValue: 0,
            handValues: {
                BlackDragon: 13,
                GoldenDragon: 8,
                RedDragon: 12,
                Tiger: 2
            },
            winner: [0, 0, 0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758699977812
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10888,
        openTime: 1758699981826,
        state: {
            cards: [
                {
                    card: 310,
                    index: 0
                },
                {
                    card: 206,
                    index: 1
                },
                {
                    card: 112,
                    index: 2
                },
                {
                    card: 201,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10888,
            handValue: 0,
            handValues: {
                BlackDragon: 6,
                GoldenDragon: 10,
                RedDragon: 12,
                Tiger: 1
            },
            winner: [0, 0, 0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700021376
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10889,
        openTime: 1758700025386,
        state: {
            cards: [
                {
                    card: 101,
                    index: 0
                },
                {
                    card: 305,
                    index: 1
                },
                {
                    card: 308,
                    index: 2
                },
                {
                    card: 109,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10889,
            handValue: 0,
            handValues: {
                BlackDragon: 5,
                GoldenDragon: 1,
                RedDragon: 8,
                Tiger: 9
            },
            winner: [1, 1, 1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700064935
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10890,
        openTime: 1758700068945,
        state: {
            cards: [
                {
                    card: 108,
                    index: 0
                },
                {
                    card: 213,
                    index: 1
                },
                {
                    card: 312,
                    index: 2
                },
                {
                    card: 108,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10890,
            handValue: 0,
            handValues: {
                BlackDragon: 13,
                GoldenDragon: 8,
                RedDragon: 12,
                Tiger: 8
            },
            winner: [2, 0, 0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700108493
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10891,
        openTime: 1758700112504,
        state: {
            cards: [
                {
                    card: 302,
                    index: 0
                },
                {
                    card: 207,
                    index: 1
                },
                {
                    card: 407,
                    index: 2
                },
                {
                    card: 201,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10891,
            handValue: 0,
            handValues: {
                BlackDragon: 7,
                GoldenDragon: 2,
                RedDragon: 7,
                Tiger: 1
            },
            winner: [0, 0, 0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700152051
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10892,
        openTime: 1758700156063,
        state: {
            cards: [
                {
                    card: 102,
                    index: 0
                },
                {
                    card: 203,
                    index: 1
                },
                {
                    card: 406,
                    index: 2
                },
                {
                    card: 203,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10892,
            handValue: 0,
            handValues: {
                BlackDragon: 3,
                GoldenDragon: 2,
                RedDragon: 6,
                Tiger: 3
            },
            winner: [1, 2, 0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700195614
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10893,
        openTime: 1758700199629,
        state: {
            cards: [
                {
                    card: 308,
                    index: 0
                },
                {
                    card: 307,
                    index: 1
                },
                {
                    card: 205,
                    index: 2
                },
                {
                    card: 404,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10893,
            handValue: 0,
            handValues: {
                BlackDragon: 7,
                GoldenDragon: 8,
                RedDragon: 5,
                Tiger: 4
            },
            winner: [0, 0, 0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700239183
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10894,
        openTime: 1758700243199,
        state: {
            cards: [
                {
                    card: 203,
                    index: 0
                },
                {
                    card: 311,
                    index: 1
                },
                {
                    card: 402,
                    index: 2
                },
                {
                    card: 103,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10894,
            handValue: 0,
            handValues: {
                BlackDragon: 11,
                GoldenDragon: 3,
                RedDragon: 2,
                Tiger: 3
            },
            winner: [2, 0, 1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700282746
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10895,
        openTime: 1758700286756,
        state: {
            cards: [
                {
                    card: 107,
                    index: 0
                },
                {
                    card: 203,
                    index: 1
                },
                {
                    card: 308,
                    index: 2
                },
                {
                    card: 103,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10895,
            handValue: 0,
            handValues: {
                BlackDragon: 3,
                GoldenDragon: 7,
                RedDragon: 8,
                Tiger: 3
            },
            winner: [0, 2, 0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700326305
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10896,
        openTime: 1758700330317,
        state: {
            cards: [
                {
                    card: 205,
                    index: 0
                },
                {
                    card: 206,
                    index: 1
                },
                {
                    card: 304,
                    index: 2
                },
                {
                    card: 212,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10896,
            handValue: 0,
            handValues: {
                BlackDragon: 6,
                GoldenDragon: 5,
                RedDragon: 4,
                Tiger: 12
            },
            winner: [1, 1, 1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700369865
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10897,
        openTime: 1758700373875,
        state: {
            cards: [
                {
                    card: 207,
                    index: 0
                },
                {
                    card: 107,
                    index: 1
                },
                {
                    card: 309,
                    index: 2
                },
                {
                    card: 111,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10897,
            handValue: 0,
            handValues: {
                BlackDragon: 7,
                GoldenDragon: 7,
                RedDragon: 9,
                Tiger: 11
            },
            winner: [1, 1, 1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700413442
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10898,
        openTime: 1758700417452,
        state: {
            cards: [
                {
                    card: 102,
                    index: 0
                },
                {
                    card: 206,
                    index: 1
                },
                {
                    card: 202,
                    index: 2
                },
                {
                    card: 110,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10898,
            handValue: 0,
            handValues: {
                BlackDragon: 6,
                GoldenDragon: 2,
                RedDragon: 2,
                Tiger: 10
            },
            winner: [1, 1, 1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700457001
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10899,
        openTime: 1758700461011,
        state: {
            cards: [
                {
                    card: 406,
                    index: 0
                },
                {
                    card: 112,
                    index: 1
                },
                {
                    card: 306,
                    index: 2
                },
                {
                    card: 202,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10899,
            handValue: 0,
            handValues: {
                BlackDragon: 12,
                GoldenDragon: 6,
                RedDragon: 6,
                Tiger: 2
            },
            winner: [0, 0, 0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700500564
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10900,
        openTime: 1758700504573,
        state: {
            cards: [
                {
                    card: 411,
                    index: 0
                },
                {
                    card: 313,
                    index: 1
                },
                {
                    card: 207,
                    index: 2
                },
                {
                    card: 113,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10900,
            handValue: 0,
            handValues: {
                BlackDragon: 13,
                GoldenDragon: 11,
                RedDragon: 7,
                Tiger: 13
            },
            winner: [1, 2, 1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700544120
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10901,
        openTime: 1758700548131,
        state: {
            cards: [
                {
                    card: 108,
                    index: 0
                },
                {
                    card: 306,
                    index: 1
                },
                {
                    card: 302,
                    index: 2
                },
                {
                    card: 112,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10901,
            handValue: 0,
            handValues: {
                BlackDragon: 6,
                GoldenDragon: 8,
                RedDragon: 2,
                Tiger: 12
            },
            winner: [1, 1, 1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700587683
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10902,
        openTime: 1758700591694,
        state: {
            cards: [
                {
                    card: 204,
                    index: 0
                },
                {
                    card: 108,
                    index: 1
                },
                {
                    card: 409,
                    index: 2
                },
                {
                    card: 301,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10902,
            handValue: 0,
            handValues: {
                BlackDragon: 8,
                GoldenDragon: 4,
                RedDragon: 9,
                Tiger: 1
            },
            winner: [0, 0, 0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700631239
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10903,
        openTime: 1758700635253,
        state: {
            cards: [
                {
                    card: 406,
                    index: 0
                },
                {
                    card: 205,
                    index: 1
                },
                {
                    card: 213,
                    index: 2
                },
                {
                    card: 207,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10903,
            handValue: 0,
            handValues: {
                BlackDragon: 5,
                GoldenDragon: 6,
                RedDragon: 13,
                Tiger: 7
            },
            winner: [1, 1, 0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700674800
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10904,
        openTime: 1758700678810,
        state: {
            cards: [
                {
                    card: 102,
                    index: 0
                },
                {
                    card: 413,
                    index: 1
                },
                {
                    card: 309,
                    index: 2
                },
                {
                    card: 403,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10904,
            handValue: 0,
            handValues: {
                BlackDragon: 13,
                GoldenDragon: 2,
                RedDragon: 9,
                Tiger: 3
            },
            winner: [1, 0, 0]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700718359
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10905,
        openTime: 1758700722373,
        state: {
            cards: [
                {
                    card: 305,
                    index: 0
                },
                {
                    card: 408,
                    index: 1
                },
                {
                    card: 209,
                    index: 2
                },
                {
                    card: 410,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10905,
            handValue: 0,
            handValues: {
                BlackDragon: 8,
                GoldenDragon: 5,
                RedDragon: 9,
                Tiger: 10
            },
            winner: [1, 1, 1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700761924
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10906,
        openTime: 1758700765934,
        state: {
            cards: [
                {
                    card: 104,
                    index: 0
                },
                {
                    card: 304,
                    index: 1
                },
                {
                    card: 108,
                    index: 2
                },
                {
                    card: 111,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10906,
            handValue: 0,
            handValues: {
                BlackDragon: 4,
                GoldenDragon: 4,
                RedDragon: 8,
                Tiger: 11
            },
            winner: [1, 1, 1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700805477
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10907,
        openTime: 1758700809487,
        state: {
            cards: [
                {
                    card: 104,
                    index: 0
                },
                {
                    card: 402,
                    index: 1
                },
                {
                    card: 202,
                    index: 2
                },
                {
                    card: 209,
                    index: 3
                }
            ],
            extraData: null,
            gameNumber: 10907,
            handValue: 0,
            handValues: {
                BlackDragon: 2,
                GoldenDragon: 4,
                RedDragon: 2,
                Tiger: 9
            },
            winner: [1, 1, 1]
        },
        status: 'Closed',
        table: '',
        updateTime: 1758700849034
    },
    {
        croupier: '529866341a8007e0',
        gameType: 'ThreeHeadedDragon' as GameType,
        id: 10908,
        openTime: 1758700853043,
        state: null,
        status: 'Open',
        table: '',
        updateTime: 1758700853043
    }
];
